import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import "./Contact.css"
import { countries } from "../components/Countries"
import videoTest8 from "../assets/videocontact.mp4"
import emailjs from "@emailjs/browser"

const Contact = () => {
  const { t } = useTranslation()
  const formRef = useRef()
  const [status, setStatus] = useState("")

  const sendEmail = (e) => {
    e.preventDefault()
    setStatus("sending")

    emailjs
      .sendForm(
        "service_28m9gc8",   // service ID
        "template_83wki59", // template ID
        formRef.current,
        "o4P7u8u4sJRhc8SgD" // public key
      )
      .then(
        () => {
          setStatus("success")
          formRef.current.reset()
        },
        () => {
          setStatus("error")
        }
      )
  }

  return (
    <div className="contact-wrapper">
      <div className="contact-hero">
        <video className="hero-video" autoPlay loop muted playsInline>
          <source src={videoTest8} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="contact-hero-overlay">
          <h1>{t("contact.hero.title")}</h1>
          <p>{t("contact.hero.subtitle")}</p>
        </div>
        <svg
          className="contact-hero-curve"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 150"
          preserveAspectRatio="none"
        >
          <path
            d="M0,0 C480,150 960,150 1440,0 L1440,150 L0,150 Z"
            fill="#1e3a5f"
          />
        </svg>
      </div>

      <main className="contact-main">
        <div className="contact-grid">
          <div className="contact-info animated-box">
            <div className="info-block">
              <svg width="24" height="24" fill="#a0d6b4" viewBox="0 0 24 24">
                <path d="M2 4a2 2 0 012-2h16a2 2 0 012 2v1l-10 6L2 5V4zm0 3.236l9.428 5.657a1 1 0 001.144 0L22 7.236V20a2 2 0 01-2 2H4a2 2 0 01-2-2V7.236z" />
              </svg>
              <div>
                <h3>{t("contact.info.email.label")}</h3>
                <p>{t("contact.info.email.value")}</p>
              </div>
            </div>

            <div className="info-block">
              <svg width="24" height="24" fill="#a0d6b4" viewBox="0 0 24 24">
                <path d="M6.62 10.79a15.91 15.91 0 006.59 6.59l2.2-2.2a1 1 0 011.06-.24 11.72 11.72 0 003.68.59 1 1 0 011 1v3.61a1 1 0 01-1 1A17 17 0 013 5a1 1 0 011-1h3.61a1 1 0 011 1 11.72 11.72 0 00.59 3.68 1 1 0 01-.24 1.06l-2.2 2.2z" />
              </svg>
              <div>
                <h3>{t("contact.info.phone.label")}</h3>
                <p>{t("contact.info.phone.value")}</p>
              </div>
            </div>

            <div className="info-block">
              <svg width="24" height="24" fill="#a0d6b4" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
              </svg>
              <div>
                <h3>{t("contact.info.location.label")}</h3>
                <p>{t("contact.info.location.value")}</p>
              </div>
            </div>

            <div className="map-container">
              <iframe
                title="Google Map"
                src="https://maps.google.com/maps?q=Makkah&t=&z=13&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          <div className="contact-form animated-box">
            <h2 className="highlight">{t("contact.form.title")}</h2>
            <form ref={formRef} onSubmit={sendEmail}>
              <input type="text" name="firstName" placeholder={t("contact.form.firstName")} required />
              <input type="text" name="lastName" placeholder={t("contact.form.lastName")} required />
              <input type="email" name="email" placeholder={t("contact.form.email")} required />
              <input type="tel" name="phone" placeholder={t("contact.form.phone")} />
              <select name="country" required>
                <option value="">{t("contact.form.country")}</option>
                {countries.map((country, index) => (
                  <option key={index} value={country}>{country}</option>
                ))}
              </select>
              <input type="text" name="subject" placeholder={t("contact.form.subject")} required />
              <textarea name="message" placeholder={t("contact.form.message")} rows="4" required></textarea>
              <button type="submit" className="animated-button">
                {status === "sending" ? t("contact.form.sending") : t("contact.form.button")}
              </button>
            </form>

            {status === "success" && <p className="success-msg">{t("contact.form.success")}</p>}
            {status === "error" && <p className="error-msg">{t("contact.form.error")}</p>}
          </div>
        </div>
      </main>
    </div>
  )
}

export default Contact